// extracted by mini-css-extract-plugin
export default {"formGrid":"styles_formGrid__pDyrq","buttonContainer":"styles_buttonContainer__o1-zq","switchContainer":"styles_switchContainer__Aclmr","switchItem":"styles_switchItem__8k9MB"};